import { useQuery } from '@tanstack/react-query';

import { standbyStylistsQuery } from '@/api/standby/standbyStylistsQuery';

import type { UseStandbyStylistsQueryOptions } from './types';

export const useStandbyStylistsQuery = (
  shopId: string,
  options?: UseStandbyStylistsQueryOptions,
) =>
  useQuery({
    ...standbyStylistsQuery(shopId),
    ...options,
    // A caller's `enabled` must never re-open the factory's required-ID guard —
    // without this, `{ enabled: true }` with no shopId would fire a query whose
    // queryFn throws. Matches useStandbyPublicShopQuery.
    enabled: !!shopId && (options?.enabled ?? true),
  });
